import { useState, createContext, useEffect, useContext } from 'react';
import Sound from '../../resources/audio/sos_siren_compass_alert.mp3';

export const HandleAudioContext = createContext();
export const HandleAudioProvider = ({ children }) => {
  const [canPlaySound, setCanPlaySound] = useState(false);
  const [audio] = useState(new Audio(Sound));
  audio.loop = true;
  let timer;

  useEffect(() => {
    const handleInteraction = () => {
      setCanPlaySound(true);
    };
    document.addEventListener('click', handleInteraction, true);
    document.addEventListener('scroll', handleInteraction, true);
    return () => {
      document.removeEventListener('click', handleInteraction('click'));
      document.removeEventListener('scroll', handleInteraction('scroll'));
    };
  }, []);

  const handleUserInteraction = () => {
    stopSound();
  };

  const playSound = () => {
    if (canPlaySound) {
      window.addEventListener('click', handleUserInteraction);
      audio.play();
      timer = setTimeout(() => {
        stopSound();
      }, 63000);
    }
  };

  const stopSound = () => {
    clearTimeout(timer);
    audio.pause();
    audio.currentTime = 0;
  };

  return (
    <HandleAudioContext.Provider value={{ playSound, stopSound, canPlaySound }}>
      {children}
    </HandleAudioContext.Provider>
  );
};

export const useHandleAudioProvider = () => {
  return useContext(HandleAudioContext);
};
